/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DashboardControllerDtoGetDashboardDataMiningStatistics model module.
 * @module model/DashboardControllerDtoGetDashboardDataMiningStatistics
 * @version 1.0
 */
class DashboardControllerDtoGetDashboardDataMiningStatistics {
    /**
     * Constructs a new <code>DashboardControllerDtoGetDashboardDataMiningStatistics</code>.
     * @alias module:model/DashboardControllerDtoGetDashboardDataMiningStatistics
     */
    constructor() { 
        
        DashboardControllerDtoGetDashboardDataMiningStatistics.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardControllerDtoGetDashboardDataMiningStatistics</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardControllerDtoGetDashboardDataMiningStatistics} obj Optional instance to populate.
     * @return {module:model/DashboardControllerDtoGetDashboardDataMiningStatistics} The populated <code>DashboardControllerDtoGetDashboardDataMiningStatistics</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardControllerDtoGetDashboardDataMiningStatistics();

            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Date');
            }
            if (data.hasOwnProperty('miningPer')) {
                obj['miningPer'] = ApiClient.convertToType(data['miningPer'], 'Number');
            }
            if (data.hasOwnProperty('miningXper')) {
                obj['miningXper'] = ApiClient.convertToType(data['miningXper'], 'Number');
            }
            if (data.hasOwnProperty('spendingPer')) {
                obj['spendingPer'] = ApiClient.convertToType(data['spendingPer'], 'Number');
            }
            if (data.hasOwnProperty('spendingXper')) {
                obj['spendingXper'] = ApiClient.convertToType(data['spendingXper'], 'Number');
            }
            if (data.hasOwnProperty('spendingHvh')) {
                obj['spendingHvh'] = ApiClient.convertToType(data['spendingHvh'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardControllerDtoGetDashboardDataMiningStatistics</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardControllerDtoGetDashboardDataMiningStatistics</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} timestamp
 */
DashboardControllerDtoGetDashboardDataMiningStatistics.prototype['timestamp'] = undefined;

/**
 * @member {Number} miningPer
 */
DashboardControllerDtoGetDashboardDataMiningStatistics.prototype['miningPer'] = undefined;

/**
 * @member {Number} miningXper
 */
DashboardControllerDtoGetDashboardDataMiningStatistics.prototype['miningXper'] = undefined;

/**
 * @member {Number} spendingPer
 */
DashboardControllerDtoGetDashboardDataMiningStatistics.prototype['spendingPer'] = undefined;

/**
 * @member {Number} spendingXper
 */
DashboardControllerDtoGetDashboardDataMiningStatistics.prototype['spendingXper'] = undefined;

/**
 * @member {Number} spendingHvh
 */
DashboardControllerDtoGetDashboardDataMiningStatistics.prototype['spendingHvh'] = undefined;






export default DashboardControllerDtoGetDashboardDataMiningStatistics;

